export const staffNavigation = {
    staff: {
        name: 'Dashboard',
        href: '/staff'
    },
    users: {
        name: 'Database Search',
        href: '/staff/user'
    },
    partner: {
        name: 'Partner Admin',
        href: '/staff/partner'
    },
    notification: {
        name: 'Notification',
        href: '/staff/notification'
    }
};
